(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["freegifts-snippet"] && !Shopify.designMode) return;
  try {
    function obviousRefreshGiftMessage() {
    const gifts = window.FGSECOMAPP;
    if (gifts && typeof gifts.renderPromotionMessage === 'function') {
      gifts.renderPromotionMessage(gifts.offers);
    }
  }
  document.addEventListener('click', (event) => {
    if (event.target.closest('.icon.icon-cart')) {
      window.setTimeout(obviousRefreshGiftMessage, 300);
    }
  });
  document.addEventListener('fg-gifts:added', obviousRefreshGiftMessage);
  } catch(e) { console.error(e); }
})();

})();
